import { render, staticRenderFns } from "./BoardTimeline.vue?vue&type=template&id=4a41e3b0&scoped=true&"
import script from "./BoardTimeline.vue?vue&type=script&lang=js&"
export * from "./BoardTimeline.vue?vue&type=script&lang=js&"
import style0 from "./BoardTimeline.vue?vue&type=style&index=0&id=4a41e3b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a41e3b0",
  null
  
)

export default component.exports